import { useApi } from "~/composables/useApi";
import type { CoverResponse } from "@asap/shared/schemas/credit-insurance";

export const useCreditInsurerCover = () => {
  const { invoke } = useApi();

  const selectAllByCompany = async (companyId: string): Promise<CoverResponse[]> => {
    const response = await invoke({
      path: "companies/:companyId/credit-insurer-covers",
      method: "GET",
      params: { companyId },
    });

    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  };

  const syncByCompany = async (companyId: string): Promise<CoverResponse[]> => {
    const response = await invoke({
      path: "companies/:companyId/credit-insurer-covers/sync",
      method: "POST",
      params: { companyId },
    });

    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  };

  return { selectAllByCompany, syncByCompany };
};
